import { HomeTabType, HomeViewType } from '@/core/presenter/viewModel/viewTypes';
import PropertyArea from './PropertyArea';
import ActivityArea from './ActivityArea';
import clsx from 'clsx';
import * as ViewModel from '@/core/presenter/viewModel';

interface IProps {
  activities: ViewModel.IResponseActivity[];
  isNotActivities: boolean;
  trxAsset?: ViewModel.IAsset;
  tokenAsset?: ViewModel.IAsset;
  trxBalance: string;
  tokenBalance: string;
  trxKrw: string;
  tokenKrw: string;
  activeTab: ViewModel.HomeTabType;
  trxPrice: number;
  tokenPrice: number;
  onClickActiveTab: (tab: ViewModel.HomeTabType) => void;
  onClickViewType: (viewType: HomeViewType) => void;
  onClickPrevTransactionBtn: () => void;
}

const HomeTab = ({
  activities,
  isNotActivities,
  trxAsset,
  tokenAsset,
  trxBalance,
  tokenBalance,
  trxKrw,
  tokenKrw,
  activeTab,
  trxPrice,
  tokenPrice,
  onClickActiveTab,
  onClickViewType,
  onClickPrevTransactionBtn,
}: IProps): JSX.Element => {
  return (
    <>
      <div className="tab sticky-tab" id="tab">
        <ul className="txtbtn-list">
          <li className="txtbtn">
            <a
              className={clsx('tab1', {
                active: activeTab === HomeTabType.ASSETS,
              })}
              href="#"
              onClick={(event) => {
                event.preventDefault();
                onClickActiveTab(HomeTabType.ASSETS);
              }}
            >
              자산
            </a>
          </li>
          <li className="txtbtn">
            <a
              className={clsx('tab2', {
                active: activeTab === HomeTabType.ACTIVITIES,
              })}
              href="#"
              onClick={(event) => {
                event.preventDefault();
                onClickActiveTab(HomeTabType.ACTIVITIES);
              }}
            >
              활동
            </a>
          </li>
        </ul>
      </div>
      {activeTab === HomeTabType.ASSETS && (
        <PropertyArea
          trxAsset={trxAsset}
          tokenAsset={tokenAsset}
          trxBalance={trxBalance}
          tokenBalance={tokenBalance}
          trxKrw={trxKrw}
          tokenKrw={tokenKrw}
          trxPrice={trxPrice}
          tokenPrice={tokenPrice}
          onClickViewType={onClickViewType}
        />
      )}
      {activeTab === HomeTabType.ACTIVITIES && (
        <ActivityArea
          activeTab={activeTab}
          activities={activities}
          isNotActivities={isNotActivities}
          onClickPrevTransactionBtn={onClickPrevTransactionBtn}
        />
      )}
    </>
  );
};

export default HomeTab;
